import { createGlobalStyle } from 'styled-components';

export const GradientBackground = createGlobalStyle<{ gradient: string }>`
    body {
        transition: background 2s ease-in-out;
        background: ${({ gradient }) => gradient};
    }
`;
